export default __webpack_public_path__ + "static/media/img--interiors-8.8bf8975d.jpg";